import { Component, Prop, Emit, Mixins } from "vue-property-decorator";
import SBComponentVue from '@/components/SBComponentVue';

@Component({
    components: {},
})
export default class SBFaqTitle extends Mixins(SBComponentVue) {

    @Prop({
        type: String,
        default: "",
    })
    public category!: string;

}
